
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-78c19e71\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./permissionSettings.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./permissionSettings.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-78c19e71\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./permissionSettings.vue"),
  /* scopeId */
  "data-v-78c19e71",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/developerInfo/components/permissionSettings.vue
// module id = 2404
// module chunks = 68